import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { unbindOriginalSearch  } from "./helpers"

import "./styles/index.css"

console.log('Init 01');
console.log(typeof document.getElementById('header-search').onclick == 'function')

unbindOriginalSearch('form[action="/search"]');

    // document.querySelector('.site-header__icons .site-header__search').addEventListener('mousedown', ()=>{
    //     const openSearchRecos = setInterval(()=>{
    //         document.querySelector('#header-search').focus()
    //     }, 100)

    //     if(document.querySelectorAll('.ns-autocomplete').length > 0){
    //         clearInterval(openSearchRecos)
    //     }
    // })

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#header-search, #Search-In-Template",
    contentCssSelector: "#MainContent .template-search",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "description",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount",
                'alternateImageUrls',
                "skus.id",
                "skus.name",
                "skus.availability",
                'customFields.key', 
                'customFields.value',
                "tags1"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // Uncomment for Category Merchandising
    categoryCssSelector: '#MainContent .collection__header',
    isCategoryPage: () => location.pathname.indexOf('/collections') > -1,
    categoryQuery: () => {

        const categryPath = document.querySelector('.collection-grid__title');
        return {
            name: 'serp',
            products: {
                categoryPath: categryPath && categryPath?.textContent,
                // categoryId: "123456789",
                size: defaultConfig.serpSize,
                from: 0
                // filter: [{ field: "brand", value: [brandPage] }]
            }
        }
    },
}).then(()=>{
    var openSearchRecos;
    document.querySelector('.site-header__icons .site-header__search').addEventListener('mousedown', ()=>{
        openSearchRecos = setInterval(()=>{
            document.querySelector('#header-search').focus()
        }, 100)

    })
    var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting === true)
        setTimeout(() => {
            clearInterval(openSearchRecos);
        }, 500);
    }, {
        threshold: [0]
    });
    
    observer.observe(document.querySelector("s-drawer#PredictiveSearch"));
})
